<template>
  <div class="app-container">
    <el-card class="mb5">
    <div style="margin-bottom: 10px; float: right">
      <el-date-picker
        v-model="queryDateTime"
        :end-placeholder="$t('operationCenter.endDate')"
        :start-placeholder="$t('operationCenter.startDate')"
        range-separator="~"
        size="small"
        style="width: 280px; margin-right: 15px"
        type="daterange"
        value-format="yyyy-MM-dd"
      />
      <el-button
        size="small" type="primary" @click="entrySearch"
      >{{ $t('operationCenter.Procurar') }}
      </el-button>
      <el-button size="small" @click="entrySearch">{{ $t('operationCenter.reset') }}</el-button>
    </div>
    <!-- 服务质量与时效 -->
    <div class="table-title" style="margin-bottom: 20px">
      服务质量与时效 Qtd. de serviço e prazos
    </div>
    <div class="table-container">
      <!-- 表头行 -->
      <div class="table-row">
        <div class="table-cell header-cell">下单量(Qtd. dos pedidos)</div>
        <div class="table-cell header-cell">出仓量(Qtd. de saída da encomenda)</div>
        <div class="table-cell header-cell">揽收量(Coletas realizadas)</div>
        <div class="table-cell header-cell">揽收率(Porcentagem de coleta)</div>
        <div class="table-cell header-cell">准时揽收量(Coletas pontuais)</div>
        <div class="table-cell header-cell">准时揽收率(Porcentagem de coleta pontual)</div>
        <div class="table-cell header-cell">妥投量(Entregas concluídas)</div>
        <div class="table-cell header-cell">理应送达量(Qtd. do pacote deve ser entregue)</div>
        <div class="table-cell header-cell">妥投率(Porcentagem de entrega)</div>
        <div class="table-cell header-cell">准时妥投量(Entregas pontuais)</div>
        <div class="table-cell header-cell">准时妥投率(Porcentagem de entrega pontual)</div>
        <div class="table-cell header-cell">P90</div>
      </div>
      <!-- 数据行 -->
      <div class="table-row">
        <div class="table-cell data-cell">
          {{ serviceQuality.totalOrderCount.toLocaleString() || 0 }}
        </div>
        <div class="table-cell data-cell">
          {{ serviceQuality.outboundCount.toLocaleString() || 0 }}
        </div>
        <div class="table-cell data-cell">
          {{ serviceQuality.collectCount.toLocaleString() || 0 }}
        </div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(serviceQuality.collectRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
        <div class="table-cell data-cell">
          {{ serviceQuality.collectOnTimeCount.toLocaleString() || 0 }}
        </div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(serviceQuality.collectOnTimeRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
        <div class="table-cell data-cell">
          {{ serviceQuality.deliveryCount.toLocaleString() || 0 }}
        </div>
        <div class="table-cell data-cell">
          {{ serviceQuality.shouldDeliveryCount.toLocaleString() || 0 }}
        </div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(serviceQuality.deliveryRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
        <div class="table-cell data-cell">
          {{ serviceQuality.deliveryOnTimeCount.toLocaleString() || 0 }}
        </div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(serviceQuality.deliveryOnTimeRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
        <div class="table-cell data-cell">{{ serviceQuality.p90 || 0 }}</div>
      </div>
    </div>
    <!-- 数据质量与异常 -->
    <div class="table-title">数据质量与异常 Qualidade de dados e exceções</div>
    <div class="table-container">
      <!-- 表头行 -->
      <div class="table-row">
        <div class="table-cell header-cell">确认丢失量(Perdas confirmadas)</div>
        <div class="table-cell header-cell">丢失率(Porcentagem da perda)</div>
        <div class="table-cell header-cell">破损量(Encomendas danificadas)</div>
        <div class="table-cell header-cell">破损率(Porcentagem de danos)</div>
        <div class="table-cell header-cell">虚假签收量(Fake deliveries)</div>
        <div class="table-cell header-cell">虚假签收率(Porcentagem de fake d deliveries)</div>
        <div class="table-cell header-cell">
          轨迹断更超20天量(Rastreamento sem atualização há 20 dias)
        </div>
        <div class="table-cell header-cell">超时效未闭环量(Casos fora do prazo não concluídos)</div>
        <div class="table-cell header-cell">轨迹完整率(Rastreamentos completos)</div>
        <div class="table-cell header-cell">
          轨迹签收推送率(Porcentagem de envio de rastreio e assinatura)
        </div>
        <div class="table-cell header-cell">
          轨迹签收推送准时率(Porcentagem de pontualidade do envio de rastreio de assinatura)
        </div>
        <div class="table-cell header-cell">签收pdd推送率(de impulso de assinatura PDD)</div>
      </div>
      <!-- 数据行 -->
      <div class="table-row">
        <div class="table-cell data-cell">{{ dataQuality.lostCount.toLocaleString() || 0 }}</div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(dataQuality.lostRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
        <div class="table-cell data-cell">{{ dataQuality.damagedCount.toLocaleString() || 0 }}</div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(dataQuality.damagedRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
        <div class="table-cell data-cell">
          {{ dataQuality.fakeSignCount.toLocaleString() || 0 }}
        </div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(dataQuality.fakeSignRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
        <div class="table-cell data-cell">
          {{ dataQuality.trackBreakCount.toLocaleString() || 0 }}
        </div>
        <div class="table-cell data-cell">
          {{ dataQuality.timeoutUnclosedCount.toLocaleString() || 0 }}
        </div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(dataQuality.trackIntactRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(dataQuality.trackSignPushRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(dataQuality.trackSignPushOnTimeRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
        <div class="table-cell data-cell">
          {{ ((parseFloat(dataQuality.signPodPushRate) || 0) * 100).toFixed(2) + '%' }}
        </div>
      </div>
    </div>
    <div style="float: right; position: relative; z-index: 9">
      <el-button
        size="small" type="primary" @click="exportData"
      >{{ $t('operationCenter.exports') }}
      </el-button>
    </div>
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane :key="1" label="客户 Plataforma" name="customerTime">
        <customerTime v-if="isShow1" :data-quality-for-customer-list="dataQualityForCustomerList" />
      </el-tab-pane>
      <el-tab-pane :key="0" label="大区 Região" name="regionalTimeliness">
        <regionalTimeliness
          v-if="isShow"
          :data-quality-for-region-list="dataQualityForRegionList"
        />
      </el-tab-pane>
    </el-tabs>
    <!--  分页  -->
    <el-pagination
      :current-page="pageParam.pageNumber"
      :page-size="pageParam.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="pageParam.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    </el-card>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { exportChartData, SortingDashboard } from '@/api/customer';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'CustomerQualityDashboard',
  components: {
    customerTime: () => import('./component/customer.vue'),
    regionalTimeliness: () => import('./component/regionalKanBan.vue')
  },
  data() {
    return {
      activeName: 'customerTime',
      isShow: false,
      isShow1: true,
      queryDateTime: [this.getTimeArr().startDate, this.getTimeArr().endDate],
      serviceQuality: {
        collectCount: 0,
        collectOnTimeCount: 0,
        collectOnTimeRate: '0.00%',
        collectRate: '0.00%',
        deliveryCount: 0,
        deliveryOnTimeCount: 0,
        deliveryOnTimeRate: '0.00%',
        deliveryRate: '0.00%',
        outboundCount: 0,
        p90: 0,
        shouldDeliveryCount: 0,
        totalOrderCount: 0
      },
      dataQuality: {
        damagedCount: 0,
        damagedRate: '0.00%',
        fakeSignCount: 0,
        fakeSignRate: '0.00%',
        lostCount: 0,
        lostRate: '0.00%',
        signPodPushRate: '0.00%',
        timeoutUnclosedCount: 0,
        trackBreakCount: 0,
        trackIntactRate: '0.00%',
        trackSignPushOnTimeRate: '0.00%',
        trackSignPushRate: '0.00%'
      },
      dataQualityForCustomerList: [],
      dataQualityForRegionList: [],
      pageParam: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      }
    };
  },
  mounted() {
    this.entrySearch();
  },
  methods: {
    entrySearch() {
      this.getSortingDashboardArrivalDepart('serviceQuality');
      this.getSortingDashboardArrivalDepart('dataQuality');
      if (this.activeName === 'customerTime') {
        this.getSortingDashboardArrivalDepart('dataQualityForCustomer');
      }
      if (this.activeName === 'regionalTimeliness') {
        this.getSortingDashboardArrivalDepart('dataQualityForRegion');
      }
    },
    reset() {
      this.getTimeArr();
      this.pageParam.pageNumber = 10;
      this.pageParam.pageSize = 10;
      this.entrySearch();
    },
    exportData() {
      console.log('导出');
      const data = {
        dashboardType: 'CUSTOMER_QUALITY_DASHBOARD',
        chartType: 'dataQualityForCustomer',
        params: {
          startDate: '',
          endDate: ''
        }
      };
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        data.params.startDate = dayjs(this.queryDateTime[0]).format('YYYY-MM-DD');
        data.params.endDate = dayjs(this.queryDateTime[1]).format('YYYY-MM-DD');
      } else {
        this.$message.error('请选择时间范围');
        return;
      }
      if (this.activeName === 'customerTime') {
        data.chartType = 'dataQualityForCustomer';
      }
      if (this.activeName === 'regionalTimeliness') {
        data.chartType = 'dataQualityForRegion';
      }
      exportChartData(data).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    getSortingDashboardArrivalDepart(chartType) {
      const data = {
        pageNumber: this.pageParam.pageNumber,
        pageSize: this.pageParam.pageSize,
        dashboardType: 'CUSTOMER_QUALITY_DASHBOARD',
        chartType: chartType,
        params: {
          startDate: '',
          endDate: ''
        }
      };
      if (this.queryDateTime && this.queryDateTime.length > 0) {
        data.params.startDate = dayjs(this.queryDateTime[0]).format('YYYY-MM-DD');
        data.params.endDate = dayjs(this.queryDateTime[1]).format('YYYY-MM-DD');
      } else {
        this.$message.error('请选择时间范围');
        return;
      }
      SortingDashboard(data).then((res) => {
        if (res.code === 200) {
          if (chartType === 'serviceQuality') {
            if (res.data.chartData) {
              this.serviceQuality = res.data.chartData;
            }
          }
          if (chartType === 'dataQuality') {
            if (res.data.chartData) {
              this.dataQuality = res.data.chartData;
            }
          }
          if (chartType === 'dataQualityForCustomer') {
            if (res.data.chartData) {
              this.dataQualityForCustomerList = res.data.chartData;
              this.pageParam.total = res.data.statistics.total;
            }
          }
          if (chartType === 'dataQualityForRegion') {
            if (res.data.chartData) {
              this.dataQualityForRegionList = res.data.chartData;
              this.pageParam.total = res.data.statistics.total;
            }
          }
        }
      });
    },
    handleClick(tab, event) {
      this.pageParam.pageNumber = 1;
      if (tab.name === 'regionalTimeliness') {
        this.isShow1 = false;
        this.isShow = true;
        this.getSortingDashboardArrivalDepart('dataQualityForRegion');
      }
      if (tab.name === 'customerTime') {
        this.isShow = false;
        this.isShow1 = true;
        this.getSortingDashboardArrivalDepart('dataQualityForCustomer');
      }
    },
    getTimeArr() {
      return {
        endDate: dayjs().subtract(1, 'day').format('YYYY-MM-DD'),
        startDate: dayjs().subtract(1, 'day').format('YYYY-MM-DD')
      };
    },
    // 点击分页
    handleSizeChange(val) {
      this.pageParam.pageSize = val;
      this.pageParam.pageNumber = 1;
      if (this.activeName === 'customerTime') {
        this.getSortingDashboardArrivalDepart('dataQualityForCustomer');
      }
      if (this.activeName === 'regionalTimeliness') {
        this.getSortingDashboardArrivalDepart('dataQualityForRegion');
      }
    },
    handleCurrentChange(val) {
      this.pageParam.pageNumber = val;
      if (this.activeName === 'customerTime') {
        this.getSortingDashboardArrivalDepart('dataQualityForCustomer');
      }
      if (this.activeName === 'regionalTimeliness') {
        this.getSortingDashboardArrivalDepart('dataQualityForRegion');
      }
    }
  }
};
</script>

<style scoped>
.app-container >>> .el-drawer__header {
  margin-bottom: 10px;
  border-bottom: 1px solid #cccccc;
  padding-bottom: 20px;
  color: black;
}

.table-container {
  border: 1px solid #ddd;
  margin-bottom: 10px;
}

/* 表头标题 */
.table-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

/* 表格行容器 */
.table-row {
  display: flex;
}

/* 单元格通用样式 */
.table-cell {
  flex: 1;
  padding: 10px;
  border-right: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  text-align: center;
  font-size: 14px;
}

.table-cell:last-child {
  border-right: none;
}

/* 最后一行单元格无底线 */
.table-row:last-child .table-cell {
  border-bottom: none;
}

/* 表头单元格样式 */
.header-cell {
  font-weight: normal;
}

/* 数据单元格样式 */
.data-cell {
  font-size: 20px;
  font-weight: bold;
  color: #000;
}
</style>
